import baseApiClient from '@cnd_fe/ky-client'

// .env.local 파일의 환경 변수를 사용하여 API 클라이언트의 prefixUrl을 설정합니다.
export const client = baseApiClient.extend({
  // @ts-ignore
  prefixUrl: import.meta.env.VITE_RES_ADMIN_SERVICE_URL
})


